import { FocusTrap } from 'focus-trap-react';
import { h } from 'preact';
import { useRef } from 'preact/hooks';
import { VOID_FN } from '../../../../../utils';
import { useStyles } from '../../../../common/hooks';
import { DIALOG_LAYER_OPEN } from '../../../theme/constants';
import { isKeyBackward, isKeyForward } from '../../../utils/focusTrap';
import { MODAL_CONTAINER_STYLES } from './styles';

export function Modal({
  show,
  styles,
  onEscapeKeyDown = VOID_FN,
  closeComponent,
  closingButtonStyle,
  attachedTo,
  children,
  ...props
}) {
  const setStyles = useStyles();

  const modalBodyRef = useRef(null);

  const handleEscapeKeyDown = (e) => {
    if (e.keyCode === 27 /* ESC */) {
      e.preventDefault();
      e.stopPropagation();
      onEscapeKeyDown(e);
    }
  };

  return (
    <FocusTrap
      active={show}
      focusTrapOptions={{
        clickOutsideDeactivates: true,
        returnFocusOnDeactivate: false,
        isKeyForward,
        isKeyBackward
      }}
    >
      {// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        <div
          aria-modal="true"
          ref={modalBodyRef}
          onKeyDown={(e) => {
            handleEscapeKeyDown(e);
          }}
          style={{
            ...setStyles(MODAL_CONTAINER_STYLES),
            ...setStyles(styles),
            overflow: 'hidden',
            zIndex: DIALOG_LAYER_OPEN
          }}
          role="dialog"
          {...props}
        >
          {/* Using a role here cause VoiceOver issues */}
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            style={{ height: '100%' }}
            onClick={(e) => e.stopPropagation()}
            onKeyPress={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <div style={closingButtonStyle}>{closeComponent}</div>
            {children}
          </div>
        </div>
      }
    </FocusTrap>
  );
}
